/**
 * @generated SignedSource<<05b5d2d5333b5bbbbbd46e76719e7f00>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type RendererContentState_content$data = {
  readonly contentState: {
    readonly color: string;
    readonly id: string | null;
    readonly name: string;
    readonly restrictionLevel: ContentStateRestrictionLevel;
  } | null;
  readonly contentStateLastUpdated: {
    readonly value: string;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "RendererContentState_content";
};
export type RendererContentState_content$key = {
  readonly " $data"?: RendererContentState_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"RendererContentState_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RendererContentState_content",
  "selections": [
    (v0/*: any*/),
    {
      "args": [
        {
          "kind": "Literal",
          "name": "isDraft",
          "value": false
        }
      ],
      "concreteType": "ContentState",
      "kind": "LinkedField",
      "name": "contentState",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        },
        {
          "kind": "ScalarField",
          "name": "restrictionLevel"
        }
      ],
      "storageKey": "contentState(isDraft:false)"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "USER_FRIENDLY"
        }
      ],
      "concreteType": "ConfluenceDate",
      "kind": "LinkedField",
      "name": "contentStateLastUpdated",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ],
      "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "0f9f2dde9d4be6b365b2ad0a7bb7d408";

export default node;
